import Cookies from 'js-cookie';

import {
  FETCH_SIGN_IN_CONTENT,
  FETCH_SIGN_IN_CONTENT_SUCCESS,
  FETCH_SIGN_IN_CONTENT_FAILED,
  SIGN_IN_ACCOUNT_MESSAGE,
  SIGN_IN_ACCOUNT_MESSAGE_SUCCESS,
  SIGN_IN_ACCOUNT_MESSAGE_FAILED,
  SIGN_IN_ACCOUNT_POPUP_MESSAGE,
  SIGN_IN_ACCOUNT_POPUP_MESSAGE_SUCCESS,
  SIGN_IN_ACCOUNT_POPUP_MESSAGE_FAILED
} from "../actions/actionTypes";
import { getAuthUserToken } from '../../helpers/authToken';

const initialState = {
  isLoading: true,
  content: {},
  error: false,
  isFormProcessing: false,
  authToken: getAuthUserToken(),
  memData: null
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case FETCH_SIGN_IN_CONTENT:
      return {
        ...state,
        isLoading: true,
        content: {}
      };
    case FETCH_SIGN_IN_CONTENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        content: payload
      };
    case FETCH_SIGN_IN_CONTENT_FAILED:
      return {
        ...state,
        isLoading: false,
        error: payload
      };
    case SIGN_IN_ACCOUNT_MESSAGE:
      return {
        ...state,
        isFormProcessing: true
      };
    case SIGN_IN_ACCOUNT_MESSAGE_SUCCESS:
      const authToken = payload.authToken;
      const expiresIn = 30 * 24 * 60 * 60 * 1000; // 7 days in ms
      const expiryTime = Date.now() + expiresIn;

      localStorage.setItem("authToken", authToken);
      localStorage.setItem("authTokenExpiry", expiryTime);
      // localStorage.setItem("authToken", payload.authToken);
      if(process.env.REACT_APP_ENV_MODE==='development'){
              Cookies.set("authToken",  payload.authToken, {
                domain: "localhost",  // don't use .ukvisajobs.com here
                path: "/",
                sameSite: "Lax",      // "None" requires https
                secure: false,        // must be false on http://localhost
                expires: 30
              });
      
            }
            else{
              Cookies.set('authToken', payload.authToken, {
                domain: process.env.REACT_APP_DOMAIN,
                path: '/',
                secure: true,
                sameSite: 'None',
                expires: 30 // 7 days, adjust as needed
              });
            }

      // Cookies.set('authToken', payload.authToken, { domain: '.ukvisajobs.com', path: '/', secure: true, sameSite: 'None' });
      // Cookies.set('authToken', payload.authToken, { path: '/', secure: false, sameSite: 'Lax' });


      return {
        ...state,
        isFormProcessing: true
      };
    case SIGN_IN_ACCOUNT_MESSAGE_FAILED:
      return {
        ...state,
        isFormProcessing: false,
        error: payload
      };
    case SIGN_IN_ACCOUNT_POPUP_MESSAGE:
      return {
        ...state,
        isFormProcessing: true
      };
    case SIGN_IN_ACCOUNT_POPUP_MESSAGE_SUCCESS:
      localStorage.setItem("authToken", payload.authToken);
      return {
        ...state,
        authToken: payload.authToken,
        isFormProcessing: true
      };
    case SIGN_IN_ACCOUNT_POPUP_MESSAGE_FAILED:
      return {
        ...state,
        isFormProcessing: false,
        error: payload
      };
    default:
      return state;
  }
}
